import { baseApi } from "../baseApi";
import {
  EditContact,
  GetContactsResponse,
  YouthListForAdult
} from "./type";

export const contactApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    getContacts: build.query<
      GetContactsResponse,
      {
        page?: number;
        limit?: number;
        search?: string;
        shareableOnly?: boolean;
      }
    >({
      query: (params = { page: 1, limit: 10 }) => ({
        url: "/youth/contacts",
        method: "GET",
        params: {
          page: params.page || 1,
          limit: params.limit || 10,
          name: params.search || "",
          shareableOnly: params.shareableOnly,
        },
      }),
      providesTags: ["Contacts"],
    }),
    getYouthListForAdult: build.query<YouthListForAdult[], void>({
      query: () => "/adult/youth/assigned",
    }),
    addContact: build.mutation<
      { message: string; statusCode: number },
      {
        firstName: string;
        lastName: string;
        email: string;
        role: string;
        phoneNumber?: string;
      }
    >({
      query: ({ firstName, lastName, email, role, phoneNumber }) => ({
        url: "/youth/contacts/add",
        method: "POST",
        body: { firstName, lastName, email, role, phoneNumber },
      }),
      invalidatesTags: ["Contacts"],
    }),
    updateContact: build.mutation<
      { message: string; statusCode: number },
      EditContact
    >({
      query: ({ resourceId, firstName, lastName, email, role, phoneNumber }) => ({
        url: `/youth/contacts/${resourceId}`,
        method: "PATCH",
        body: { firstName, lastName, email, role, phoneNumber },
      }),
      invalidatesTags: ["Contacts"],
    }),
    deleteContact: build.mutation<
      { message: string; statusCode: number },
      { resourceId: string }
    >({
      query: ({ resourceId }) => ({
        url: `/youth/contacts/remove/${resourceId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Contacts"],
    }),
  }),
});

export const {
  useGetContactsQuery,
  useGetYouthListForAdultQuery,
  useAddContactMutation,
  useDeleteContactMutation,
  useUpdateContactMutation,
} = contactApi;
